import { commandDefinition, optionsDefinition } from "../../Commons/Options/CommandBasedOptionsParser";
import { BuildDebugOnlyOption, debugOnlyOptionDefinition } from "../CommonOptions/BuildDebugOnlyOption";
import { CommonOptions } from "../CommonOptions/CommonOptions";
import { devModeOption, logVerbosityOption } from "../CommonOptions/CommonOptionDefintions";

export interface BuildServerOptions extends CommonOptions, BuildDebugOnlyOption {
    disableClientOverride: boolean;
    nightly: boolean;
    allFarmsDir: string[] | [];
}

export interface DevBuildServerOptions extends CommonOptions, BuildDebugOnlyOption {
    formGlobs: string[];
    disableClientOverride: boolean;
    allFarmsDir: string[] | [];
}

export const buildServerCommandDefinition = commandDefinition<"build-server", BuildServerOptions>(
    "build-server",
    "build-server",
    optionsDefinition(
        {
            alias: "g",
            name: "gfvs",
            defaultValue: {},
            parse: () => ({}),
            defaultOption: true,
            multiple: true,
            description: "Опция устарела. Оставлена для обратной совместимости.",
        },
        {
            alias: "a",
            name: "all-farm-dir",
            defaultValue: { allFarmsDir: [] },
            parse: (input: string[]) => ({ allFarmsDir: input }),
            defaultOption: false,
            multiple: true,
            description:
                "Позволяет передать массив путей до всех фармов candy, чтобы открывать из всех них формы. Путь передавать относительно candy",
        },
        {
            name: "nightly",
            defaultValue: { nightly: false },
            parse: input => ({ nightly: input }),
            doesNotRequireValue: true,
            description: "Включает сборку форм на движке nightly.",
        },
        {
            name: "no-client-override",
            defaultValue: { disableClientOverride: false },
            parse: input => ({ disableClientOverride: input }),
            doesNotRequireValue: true,
            description:
                "Отключает перехват client.js. В этом случае не будет работать отображение логов сборки и ожидания сборки формы.",
        },
        debugOnlyOptionDefinition,
        devModeOption,
        logVerbosityOption
    ),
    {
        description: "Magic",
    }
);

export const devBuildServerCommandDefinition = commandDefinition<"dev-build-server", DevBuildServerOptions>(
    "dev-build-server",
    "dev-build-server",
    optionsDefinition(
        {
            alias: "g",
            name: "gfvs",
            defaultValue: { formGlobs: ["*"] },
            parse: (input: string[]) => ({ formGlobs: input }),
            defaultOption: true,
            multiple: true,
            description: "Одна или несколько GFV или GFV-масок для пересобрки.",
        },
        {
            alias: "a",
            name: "all-farm-dir",
            defaultValue: { allFarmsDir: [] },
            parse: (input: string[]) => ({ allFarmsDir: input }),
            defaultOption: false,
            multiple: true,
            description:
                "Позволяет передать массив путей до всех фармов candy, чтобы открывать из всех них формы. Путь передавать относительно candy",
        },
        {
            name: "no-client-override",
            defaultValue: { disableClientOverride: false },
            parse: input => ({ disableClientOverride: input }),
            doesNotRequireValue: true,
            description:
                "Отключает перехват client.js. В этом случае не будет работать отображение логов сборки и ожидания сборки формы.",
        },
        debugOnlyOptionDefinition,
        devModeOption,
        logVerbosityOption
    ),
    {
        description: "Magic",
    }
);
